/**
 * Custom Hook for Currency Formatting
 */

import { useCallback } from 'react';
import { useSettings } from './useSettings';
import { formatCurrency as formatCurrencyUtil, formatCurrencyWithSpacing as formatCurrencyWithSpacingUtil, getCurrencySymbol as getCurrencySymbolUtil, CurrencyCode } from '../utils/currency';

export function useCurrency() {
  const { getCurrency } = useSettings();

  const formatCurrency = useCallback(
    (amount: number | string, includeDecimals: boolean = true): string => {
      const currency = getCurrency();
      return formatCurrencyUtil(amount, currency, includeDecimals);
    },
    [getCurrency]
  );

  const formatCurrencyWithCode = useCallback(
    (amount: number | string, currencyCode: CurrencyCode, includeDecimals: boolean = true): string => {
      return formatCurrencyUtil(amount, currencyCode, includeDecimals);
    },
    []
  );

  const formatCurrencySpaced = useCallback(
    (amount: number | string, includeDecimals: boolean = true): string => {
      const currency = getCurrency();
      return formatCurrencyWithSpacingUtil(amount, currency, includeDecimals);
    },
    [getCurrency]
  );

  const getCurrencySymbol = useCallback((): string => {
    const currency = getCurrency();
    return getCurrencySymbolUtil(currency);
  }, [getCurrency]);

  return {
    formatCurrency,
    formatCurrencyWithCode,
    formatCurrencySpaced,
    getCurrencySymbol,
    currency: getCurrency(),
  };
}